export function ensureShopifyAppBridge(apiKey?: string | null): void {
  if (typeof document === "undefined") {
    return;
  }

  const trimmedApiKey = apiKey?.trim();
  if (!trimmedApiKey) {
    return;
  }

  let metaTag = document.querySelector('meta[name="shopify-api-key"]');
  if (!metaTag) {
    metaTag = document.createElement("meta");
    metaTag.setAttribute("name", "shopify-api-key");
    document.head.appendChild(metaTag);
  }
  metaTag.setAttribute("content", trimmedApiKey);

  if (!document.querySelector('script[data-shopify-app-bridge="true"]')) {
    const script = document.createElement("script");
    script.src = "https://cdn.shopify.com/shopifycloud/app-bridge.js";
    script.async = true;
    script.dataset.shopifyAppBridge = "true";
    document.head.appendChild(script);
  }
}

export function clearShopifyAppBridge(): void {
  if (typeof document === "undefined") {
    return;
  }

  const metaTag = document.querySelector('meta[name="shopify-api-key"]');
  metaTag?.remove();

  const script = document.querySelector('script[data-shopify-app-bridge="true"]');
  script?.remove();
}
